<template>
  <b-container>

    <!-- Title bar -->
    <div class="title-bar">
      <h1> {{ $t("labels.settings") }}</h1>
    </div>
    <b-row>
      <b-col>
        <h2>{{ $t("meta.administratie") }}</h2>
        <b-button-group vertical>
          <b-button active-class="active" v-if="true && current_user.role == 'admin'" to="/emailsettings">
            <font-awesome-icon icon="envelope" /> {{ $t("buttons.emailtemplates") }}
          </b-button>
          <b-button active-class="active" v-if="true && current_user.role == 'admin'" to="/emailsenders">
            <font-awesome-icon icon="envelope" /> {{ $t("buttons.emailsenders") }}
          </b-button>
          <b-button active-class="active" v-if="true && current_user.role == 'admin'" to="/cronsettings">
            <font-awesome-icon icon="spider" /> {{ $t("buttons.cronsettings") }}
          </b-button>   
        </b-button-group>

      </b-col>
    </b-row>
    <hr>
    <div class="form-row">
      <div @click="save_settings" class="btn btn-primary">
        <font-awesome-icon icon="save" /> {{ $t("buttons.savesettings") }}
           </div>
    </div>

    <br>
    <!-- <div v-if="createAny('project')" @click="css()" class="btn btn-primary">
      <font-awesome-icon icon="plus" />css
    </div> -->
    <!-- <div v-if="createAny('project')" @click="sendWhatsapp()" class="btn btn-primary">
      <font-awesome-icon icon="plus" />whatsapp
    </div> -->
     <!-- <h1> IMPORT ZZPers </h1>
    <textarea style="width:100%; height:300px" v-model="importdata" />

    <div v-if="createAny('project')" @click="parseimportZZPR()" class="btn btn-primary">
      <font-awesome-icon icon="plus" />importusers
    </div> -->
    <!-- 
    <h1> IMPORT users </h1>
    <textarea style="width:100%; height:300px" v-model="importdata" />

    <div v-if="createAny('project')" @click="parseimportUsers()" class="btn btn-primary">
      <font-awesome-icon icon="plus" />importusers
    </div> -->

    <!-- <h1> IMPORT companies </h1>
    <textarea style="width:100%; height:300px" v-model="importdata" />

    <div v-if="createAny('project')" @click="parseimportCompany()" class="btn btn-primary">
      <font-awesome-icon icon="plus" />importcompany
    </div> -->
    <div>

    </div>
  </b-container>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapState, mapActions } from 'vuex'


export default {
  name: 'navigation',
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'createAny',
    ]),
    ...mapState([
      'current_user',
      'users',
      'settings'
    ]),

  },
  methods: {
    ...mapActions([
    ]),

    save_settings() {
      try {
        let message = {}
            message.email = "axecrazy@gmail.com"
            message.name = "test"
            message.message = "<h1>testbericht</h1><p> testbericht vanaf de FlyingFreelancers Carousel portal</p>"
            message.subject = "Testbericht"
            message.maindocuments = []
            message.sender = -1
            message.sendermail = -1
            message.sendername =  -1      
            axios.post('/api/msal/contact_user', message
            ) 
      } catch (err) {
        console.log(err)
      }
    }, 
    test (){

    },



  },
  components: {},
}
</script>